import { useId } from 'react';

import type { ChkIconProps } from './ChkIcon.types';
import { ChkSvgWrapper } from './ChkIcon.utils';

export const ChkIconProhibit = (iconProps: ChkIconProps) => {
  const clipPathId = useId();

  return (
    <ChkSvgWrapper {...iconProps}>
      <g clipPath={`#url(${clipPathId})`}>
        <path
          d="M18.3637 18.3637L5.63623 5.63623"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </ChkSvgWrapper>
  );
};
